<template>
  <div>
    <v-btn dark color="accent" right @click="loescheBetriebe()">Neue Suche</v-btn>
    <!-- <v-btn
  class="hidden-md-and-up"
  dark
  color="accent"
  @click="loescheBetriebe()"
    >Neue Suche</v-btn>-->
    <!--   
  
  <span class="headline">
    Sie suchten nach Dachdeckern
    </span>-->
  </div>
</template>

<script>

export default {

  components: {

  },
  data: () => ({

  }),
  computed: {
  //  Leistung:{

  //      get(){ return this.$store.getters.fetchSuchbegriff.leistung; },
  //      set( Leistung ){ this.$store.commit("SET_BETRIEBE_SUCHBEGRIFF", Leistung )}
  //      // set( value ){ this.$store.commit("TEST_COMMIT", value );}
  //   },
    // xxxStadt: {
    //   get() { return this.$store.getters.fetchSuchbegriff.standort },
    //   set: function(value){
    //     console.log('a ' + value)
    //     this.$store.commit("SET_BETRIEBE_STANDORT", value );}
    // }
  },
  mounted: function () {
  },

  methods: {
    loescheBetriebe () {
      // this.$store.dispatch('loescheBetriebe')
      this.$router.push({
        name: 'startseite'
      })
    }
  }
}
</script>
<style>
</style>